const textVariants = {
    betText: {
        root: {
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "20px",
        }
    },
    betTextHighlight: {
        $extendFromVariant: "betText",
        root: { color: "$gray400" }
    },
    betHeadline: {
        root: {
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            fontWeight: 600,
            fontSize: "12px",
            lineHeight: "14px",
            textTransform: "uppercase",
        }
    },
    betTitle: {
        root: {
            marginRight: "$s1",
            fontSize: "16px",
            lineHeight: "20px",
            fontWeight: 700,
            verticalAlign: "middle",
            fontFamily: "Saira Condensed, Open Sans, sans-serif",
            textTransform: "uppercase",
        },
    },
    selectionCardText: {
        root: {
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px",
        }
    },
    regularSelectionCardTitle: {
        $extendFromVariant: "betTitle",
        root: {
            flex: "1 1 auto",
            fontSize: "14px",
            lineHeight: "18px",
            fontWeight: 600,
        },
    },
    regularSelectionCardSubtitle: {
        $extendFromVariant: "selectionCardText",
        root: {
            color: "$gray400"
        }
    },
    nestedSelectionCardTitle: {
        $extendFromVariant: "regularSelectionCardTitle",
        root: {
            fontWeight: 600,
            fontSize: "12px",
            lineHeight: "14px",
        },
    },
    nestedSelectionCardSubtitle: {
        $extendFromVariant: "regularSelectionCardSubtitle",
    },
    finalScore: {
        root: {
            marginLeft: "$s0",
            fontSize: "12px",
            lineHeight: "16px",
            color: "$yellow700",
        }
    },
    boostedOdds: {
        $extendFromVariant: "betTitle",
        root: {
            color: "$green400",
        }
    },
    guaranteedOdds: {
        $extendFromVariant: "betTitle",
        root: {
            color: "$white",
        }
    },
    betOverMaxOdds: {
        $extendFromVariant: "betTitle",
        root: {
            color: "$green400",
        }
    },
    originalOdds: {
        $extendFromVariant: "betTitle",
        root: {
            color: "$gray400",
            textDecorationLine: "line-through",
        }
    },
    boostMessageRegular: {
        root: {
            color: "$gray400",
            lineHeight: "1.5",
        }
    },
    boostMessageOriginal: {
        root: {
            color: "inhirit",
            textTransform: "none",
            fontSize: "10px",
        }
    },
    boostMessageBonusDowngraded: {
        root: {
            color: "$gray400",
        }
    },
    boostMessageBonusReturned: {
        root: {
            color: "$gray400",
        }
    },
    boostMessageGhostReturned: {
        root: {
            color: "#F6B700",
            lineHeight: "1.5",
        }
    },
    boostMessageGhostWin: {
        root: {
            color: "#53D337",
            lineHeight: "1.5",
        }
    },
    boostMessageCashOut: {
        root: {
            color: "$yellow400",
            lineHeight: "1.5",
        }
    },
    notification: {
        root: {
            marginBottom: "$s2",
            paddingTop: "6px",
            paddingRight: "12px",
            paddingBottom: "6px",
            paddingLeft: "12px",
            border: "1px solid rgba(247, 208, 2, 0.2);",
            borderRadius: "4px",
            color: "$white",
            backgroundColor: "rgba(247, 208, 2, 0.1);",
        }
    },
    earlyExitMessage: {
        root: {
            fontSize: "10px",
            lineHeight: "14px",
            color: "#ABABAB",
        }
    },
    replayLabel: {
        root: {
            color: "$gray300",
            fontSize: "10px",
            lineHeight: "14px",
        }
    },
    replayPlayerName: {
        $extendFromVariant: "betHeadline",
        root: {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        }
    },
    replayRegular: {
        $extendFromVariant: "replayPlayerName",
        root: {
            fontSize: "10px",
        }
    },
};
export { textVariants };
//# sourceMappingURL=text.js.map